import React, { Component } from "react";
import _ from "lodash";
import { Button, Modal, FormControl, FormGroup } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import TimeStamp from "react-timestamp";
import * as reactDeviceDetect from "react-device-detect";
import { fire, auth } from "../../firebase/index";
import { customLog } from "../../variables/Variables";
import "../../assets/css/maincss.css";
import "../../assets/css/header.css";
import LocalizedStrings from "react-localization";
// Icons
import accountManagement from "../../assets/img/AccountManagement.png";
import lockAccess from "../../assets/img/LockAccess.png";
import loginRequest from "../../assets/img/LoginRequest.png";
import notificationStatus from "../../assets/img/notificationStatus.png";
import authorizeIMG from "../../assets/img/Authorize.png";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    PopupHeader: "Subscription Plan Expiring",
    PopupText1: "Hi, ",
    PopupText2_1:
      "A friendly reminder that your Intelligent Access Management System (IAMS) subscription plan is about to ",
    PopupText2_2: "expire",
    PopupText2_3: " on ",
    PopupText2_4: ".",
    PopupText3:
      "To prevent failure during the renewal payment process, please ensure that your card does not meet the following:",
    PopupText4:
      "Please update your payment details if the condition above is met, or that you are changing your payment method.",
    PopupText5_1:
      "If you have any questions or need help regarding the renewal process, please contact us at ",
    PopupText5_2: "support@egeetouch.com",
    PopupText5_3: ".",
    PopupTextBullet1: "Insufficient funds on the account",
    PopupTextBullet2: "Expired credit card",
    PopupButton: "Update details",
    PopupConfirmBtn: "I understand",
    showToday: " Don't show again",
  },
  ja: {
    PopupHeader: "ご契約プラン更新について",
    PopupText1: " 様",
    PopupText2_1: "インテリジェントアクセス管理システムのご契約は",
    PopupText2_2: "",
    PopupText2_3: "",
    PopupText2_4: "までとなります。",
    PopupText3:
      "ご契約期間更新のためのお支払い処理を行います。カード情報を今一度お確かめください。",
    PopupText4: "カード情報の変更については、更新情報を入力してください。",
    PopupText5_1: "ご不明な点は、",
    PopupText5_2: "support@egeetouch.com",
    PopupText5_3: "までご連絡ください。",
    PopupTextBullet1: "お取引銀行口座の残金不足",
    PopupTextBullet2: "クレジットカード有効期限切れ",
    PopupButton: "更新情報",
    PopupConfirmBtn: "承諾します",
    showToday: " 画面を閉じないでください。",
  },
  es: {
    PopupHeader: "Plan de Suscripción a Punto de Expirar",
    PopupText1: "Hola, ",
    PopupText2_1:
      "Un recordatorio amistoso de que tu plan de suscripción del Sistema de Gestión de Acceso Inteligente (IAMS) está a punto de ",
    PopupText2_2: "expirar",
    PopupText2_3: " el ",
    PopupText2_4: ".",
    PopupText3:
      "Para evitar fallos durante el proceso de renovación del pago, asegúrate de que tu tarjeta no cumple con lo siguiente:",
    PopupText4:
      "Por favor, actualiza tus detalles de pago si se cumple la condición anterior, o si estás cambiando tu método de pago.",
    PopupText5_1:
      "Si tienes alguna pregunta o necesitas ayuda con respecto al proceso de renovación, por favor contáctanos en ",
    PopupText5_2: "support@egeetouch.com",
    PopupText5_3: ".",
    PopupTextBullet1: "Fondos insuficientes en la cuenta",
    PopupTextBullet2: "Tarjeta de crédito expirada",
    PopupButton: "Actualizar detalles",
    PopupConfirmBtn: "Entiendo",
    showToday: " No mostrar de nuevo",
  },
});

class SubscriptionEndingPopup extends Component {
  constructor(props) {
    super(props);

    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.handlePopupCloseBtn = this.handlePopupCloseBtn.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.state = {
      redeemedEndTime: "",
      showPopup: false,
      showAgain: true,
      currentLanguage: "en",
    };
  }

  async componentWillMount() {
    this._isMounted = true;
    //! FOR LANGUAGE
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });

      fire
        .database()
        .ref("groupAccounts")
        .child(auth.currentUser.uid)
        .once("value")
        .then((snapshot) => {
          if (!this._isMounted) return;
          if (snapshot.exists()) {
            let userDetails = snapshot.val();

            this.setState({
              redeemedEndTime: userDetails.payment.endedOn,
            });

            fire
              .database()
              .ref("groupAccounts")
              .child(auth.currentUser.uid)
              .child("dashboardNotification")
              .child("subscription")
              .once("value")
              .then((snapshot) => {
                if (!this._isMounted) return;
                if (snapshot.exists()) {
                  if (
                    userDetails.dashboardNotification.subscription.showAgain ===
                    true
                  ) {
                    let isExpiring =
                      userDetails.dashboardNotification.subscription.expiring;
                    let showToday =
                      userDetails.dashboardNotification.subscription.showToday;

                    if (isExpiring === false || showToday === false) {
                      this.setState({
                        showPopup: false,
                      });
                    } else {
                      this.setState({
                        showPopup: true,
                      });
                    }
                  } else {
                    this.setState({
                      showPopup: false,
                    });
                  }
                } else {
                  this.setState({
                    showPopup: false,
                  });
                }
              });
          }
        });

      fire
        .database()
        .ref("registeredIndustrialUsersOnPlatform/" + auth.currentUser.uid)
        .once("value")
        .then((snapshot) => {
          if (!this._isMounted) return;
          if (snapshot.exists()) {
            let userDetails = snapshot.val();
            this.setState({
              userName: userDetails.name,
            });
          }
        });
    }
  }

  handlePopupClose() {
    this.setState({
      showPopup: false,
    });
  }

  handlePopupCloseBtn() {
    // console.log("Hello checking the pop-up")
    if (this.state.checked) {
      fire
        .database()
        .ref("groupAccounts/")
        .child(auth.currentUser.uid)
        .child("dashboardNotification")
        .child("subscription")
        .once("value")
        .then((snapshot) => {
          if (snapshot.exists()) {
            fire
              .database()
              .ref("groupAccounts/")
              .child(auth.currentUser.uid)
              .child("dashboardNotification")
              .child("subscription")
              .update({
                showAgain: false,
              });
          } else {
            fire
              .database()
              .ref("groupAccounts/")
              .child(auth.currentUser.uid)
              .child("dashboardNotification")
              .child("subscription")
              .set({
                showAgain: false,
              });
          }
        });
    }

    this.setState({
      showPopup: false,
    });
  }

  handleChange(e) {
    let isChecked = e.target.checked;

    this.setState({
      checked: isChecked,
    });
  }

  dateTimeFormat(time) {
    if (localizationStrings.getLanguage() === "ja") {
      customLog(new Intl.DateTimeFormat("ja-JP", { era: "long" }).format(time));
      customLog(
        new Intl.DateTimeFormat("ja-JP", {
          hour: "2-digit",
          minute: "2-digit",
        }).format(time)
      );
      customLog(Date.now());
      var japanDate = new Intl.DateTimeFormat("ja-JP", {
        year: "numeric",
        month: "long",
        day: "numeric",
      }).format(time);
      var japanTime = new Intl.DateTimeFormat("ja-JP", {
        hour: "2-digit",
        minute: "2-digit",
      }).format(time);
      return japanDate + japanTime;
    } else {
      // customLog(new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(time));
      return <TimeStamp time={time * 1000} format="full" includeDay />;
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! FOR LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    return (
      <div>
        <Modal
          show={this.state.showPopup}
          onHide={this.handlePopupClose}
          dialogClassName="modal-50w"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Modal.Header closeButton style={{ border: "none" }}>
            <Modal.Title
              style={{
                textAlign: "center",
                fontSize: "30px",
                marginTop: "10px",
                color: "#FF2121",
              }}
            >
              {localizationStrings.PopupHeader}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p
              className="lightFont"
              style={{ width: "90%", textAlign: "left" }}
            >
              <strong>
                {this.state.currentLanguage === "en"
                  ? localizationStrings.PopupText1 + this.state.userName
                  : this.state.userName + localizationStrings.PopupText1}
              </strong>
            </p>
            <br />
            <p
              className="lightFont"
              style={{ width: "90%", textAlign: "left" }}
            >
              {localizationStrings.PopupText2_1}
              <strong style={{ color: "#FF2121" }}>
                {localizationStrings.PopupText2_2}
              </strong>
              {localizationStrings.PopupText2_3}
              <strong>{this.dateTimeFormat(this.state.redeemedEndTime)}</strong>
              {localizationStrings.PopupText2_4}
            </p>
            <br />
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{ width: "80%", borderBottom: "1px solid #DDDCDC" }}
              ></div>
            </div>
            <br />
            <p
              className="lightFont"
              style={{ width: "80%", textAlign: "justify" }}
            >
              {localizationStrings.PopupText3}
            </p>
            <ul
              className="lightFont"
              style={{ width: "80%", textAlign: "left" }}
            >
              <li style={{ color: "#FF2121", fontSize: "30px" }}>
                <p
                  className="lightFont"
                  style={{
                    color: "#3C3E41",
                    display: "table-cell",
                    verticalAlign: "middle",
                  }}
                >
                  {localizationStrings.PopupTextBullet1}
                </p>
              </li>
              <li style={{ color: "#FF2121", fontSize: "30px" }}>
                <p
                  className="lightFont"
                  style={{
                    color: "#3C3E41",
                    display: "table-cell",
                    verticalAlign: "middle",
                  }}
                >
                  {localizationStrings.PopupTextBullet2}
                </p>
              </li>
            </ul>
            <br />
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{ width: "80%", borderBottom: "1px solid #DDDCDC" }}
              ></div>
            </div>
            <br />
            <p
              className="lightFont"
              style={{ width: "90%", textAlign: "left" }}
            >
              {localizationStrings.PopupText4}
            </p>
            <br />
            <div style={{ display: "flex", width: "90%", margin: "auto" }}>
              <NavLink
                to="/accountManagement"
                className="nav-link"
                onClick={this.handlePopupClose}
              >
                <button
                  className="boldFont"
                  style={{
                    backgroundColor: "#59A9F3",
                    color: "white",
                    border: "none",
                    height: "40px",
                    width: "200px",
                    borderRadius: "5px",
                  }}
                >
                  <p style={{ margin: "auto", padding: "auto" }}>
                    {localizationStrings.PopupButton}
                  </p>
                </button>
              </NavLink>
            </div>
            <br />
            <p
              className="lightFont"
              style={{ width: "90%", textAlign: "left" }}
            >
              {localizationStrings.PopupText5_1}
              <span style={{ color: "#369AF6", textDecoration: "underline" }}>
                <a href="mailto: support@egeetouch.com">
                  {localizationStrings.PopupText5_2}
                </a>
              </span>
              {localizationStrings.PopupText5_3}
            </p>
            <br />
            <br />
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                padding: "auto",
                margin: "auto",
              }}
            >
              <div>
                <div>
                  <input
                    type="checkbox"
                    onChange={(e) => this.handleChange(e)}
                  />{" "}
                  {localizationStrings.showToday}
                </div>
                <div style={{ height: "5px" }}></div>
                <button
                  className="boldFont"
                  style={{
                    backgroundColor: "#59A9F3",
                    color: "white",
                    border: "none",
                    height: "40px",
                    width: "200px",
                    borderRadius: "5px",
                  }}
                  onClick={this.handlePopupCloseBtn}
                >
                  <p style={{ margin: "auto", padding: "auto" }}>
                    {localizationStrings.PopupConfirmBtn}
                  </p>
                </button>
              </div>
            </div>
            <br />
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default SubscriptionEndingPopup;
